<template>
  <v-container fluid>
    <v-dialog v-model="editSynonymsDialog" width="600">
      <v-card>
        <v-card-title class="headline" primary-title
          >Edit Synonyms</v-card-title
        >
        <edit-synonyms
          v-if="entityToBeEdited"
          :item="entityToBeEdited"
          @success="handleEditSuccess"
        />
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteEntityDialog" width="400">
      <v-card v-if="selected && selected.length">
        <v-card-title class="headline" primary-title>
          Delete {{ selected.map((entity) => entity.name).join(", ") }}
        </v-card-title>
        <v-card-text> Are you sure you want to delete this Item? </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :loading="addButtonLoader"
            :disalbed="
              !$store.state.nlp.sublists.length ||
              $store.state.nlp.sublists.length <= 1
            "
            color="error"
            outline
            @click="deleteEntities"
          >
            Delete
          </v-btn>
          <v-btn
            color="black"
            class="white--text"
            @click="deleteEntityDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <h1 v-if="selectedEntity">
        Entities <span class="primary--text">({{ selectedEntity.name }})</span>
      </h1>
      <v-spacer />
      <app-actions />
    </v-layout>
    <v-flex xs12>
      <v-card class="card-curvey">
        <v-layout row wrap>
          <v-flex xs4>
            <v-text-field
              v-model="queries.q"
              placeholder="Search By Name.."
              append-icon="search"
              @keydown.enter="getSublists(true)"
              outline
            >
              <template v-slot:append>
                <v-icon
                  v-if="queries.q && queries.q.length"
                  @click="clearSearch"
                  >close</v-icon
                >
                <v-icon color="primary" @click="getSublists(true)"
                  >search</v-icon
                >
              </template>
            </v-text-field>
          </v-flex>
          <v-spacer />
          <v-btn
            :disabled="!selected || !selected.length || selected.length !== 1"
            color="blue-grey"
            class="nlp-nav-btn"
            small
            outline
            @click="deleteEntityDialog = true"
          >
            <span class="botter-trash-icon" style="padding-right: 6px" />
            Delete
          </v-btn>
        </v-layout>
        <v-flex xs12>
          <v-data-table
            ref="dataTable"
            v-model="selected"
            :headers="headers"
            :items="$store.state.nlp.sublists"
            :loading="loaders.list"
            :pagination.sync="$store.state.settings.pagination"
            item-key="name"
            select-all
            hide-actions
            class="elevation-1 nlp-data-table"
          >
            <template slot="items" slot-scope="props">
              <add-entity-sublist
                v-if="props.index === 0"
                ref="addEntitySublistFull"
                :put="
                  selected && selected.length && selected.length === 1
                    ? selected[0]
                    : null
                "
                :text-field-props="{
                  class: 'table-text-field',
                  outline: true,
                  small: true,
                  'hide-details': true,
                }"
                :container-tag="{
                  name: 'tr',
                  props: {
                    class: '',
                    style: {
                      minWidth: `${
                        $refs && $refs.dataTable
                          ? $refs.dataTable.$el.offsetWidth - 60
                          : 500
                      }px`,
                    },
                  },
                }"
                :parrier-tag="{
                  name: 'td',
                  props: { class: '', style: 'max-height: unset !important;' },
                }"
                :custom-bind="{
                  type: { class: 'text-center' },
                  typeInput: {
                    style: 'max-width: 70% !important; display: inline-block',
                  },
                }"
                @loading="addButtonLoader = $event"
                @success="createEntityDialog = false"
              >
                <td slot="before-name" class="" />
                <td slot="tail-slot-1">
                  <v-btn
                    style="
                      max-width: 30%;
                      margin-left: 0;
                      margin-right: 0 !important;
                      float: right;
                    "
                    :loading="!!addButtonLoader"
                    class="nlp-nav-btn"
                    small
                    @click="addSublist(true)"
                  >
                    <v-icon>add</v-icon>
                    Add
                  </v-btn>
                </td>
              </add-entity-sublist>
              <tr v-if="props.item.name">
                <td>
                  <v-checkbox v-model="props.selected" primary hide-details />
                </td>
                <td>
                  <span class="primary--text">
                    {{ props.item.name }}
                  </span>
                </td>
                <td class="text-left">
                  <read-more
                    :text="
                      props.item.synonyms
                        ? props.item.synonyms.map((s) => s.name).join(', ')
                        : '-'
                    "
                    :max-chars="180"
                    class="read-more-container"
                  />
                </td>
                <td v-if="headers.length > 2">
                  <v-btn
                    class="edit-synonyms-btn"
                    flat
                    @click="openEditSynonyms(props.item)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <add-entity-sublist
              ref="addEntitySublistEmpty"
              slot="no-data"
              :height-factor="2.5"
              :text-field-props="{
                class: 'table-text-field',
                outline: true,
                small: true,
                'hide-details': true,
              }"
              :container-tag="{
                name: 'tr',
                props: {
                  class: 'entities-form-container-tag',
                  style: noDataContainerTagStyles,
                },
              }"
              :parrier-tag="{
                name: 'td',
                props: {
                  class: 'entities-form-parrier-tag',
                  style: 'max-height: unset !important;',
                },
              }"
              :custom-bind="{
                typeInput: {
                  'no-data-text': 'Press Enter To Add',
                  placeholder: 'Type Your Synonyms',
                  style: 'max-width: 70% !important; display: inline-block;',
                },
                type: { style: 'min-width: 300px;' },
              }"
              @loading="addButtonLoader = $event"
              @success="createEntityDialog = false"
            >
              <v-btn
                slot="tail-slot-1"
                :loading="!!addButtonLoader"
                style="max-height: unset !important; display: inline-block"
                color="blue-grey"
                class="nlp-nav-btn"
                small
                outline
                @click="addSublist(true)"
              >
                <v-icon>add</v-icon>
                Add
              </v-btn>
            </add-entity-sublist>
          </v-data-table>
        </v-flex>
        <v-divider />
        <v-layout row wrap>
          <v-flex xs10>
            <v-layout
              justify-center
              align-content-center
              style="padding-top: 15px"
            >
              <v-pagination
                slot="footer"
                v-model="pagination.page"
                :length="paginationCount"
                :disabled="loaders.list"
                style="width: auto !important; margin: auto !important"
                @input="getSublists(false)"
              />
            </v-layout>
          </v-flex>
          <v-flex xs2 align-self-center>
            <v-spacer />
            <div style="text-align: right"><small>Items Per Page</small></div>
            <v-select
              v-model="pagination.per_page"
              :items="[5, 10, 15, 20, 25]"
              :disabled="loaders.list"
              style="width: 80px; float: right"
              outline
              @input="getSublists(false)"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import ReadMore from "vue-read-more/components/ReadMoreComponent";
import AddEntitySublist from "../../../../components/nlp/entities/AddEntitySublist.vue";
import EditSynonyms from "../../../../components/nlp/entities/EditSynonyms.vue";
import AppActions from "../../common/AppActions";
export default {
  name: "Nlp",
  components: {
    AddEntitySublist,
    EditSynonyms,
    AppActions,
    ReadMore,
  },
  data() {
    return {
      queries: {
        q: "",
      },
      pagination: {
        page: 1,
        per_page: 15,
      },
      loaders: {
        list: true,
        single: true,
      },
      createEntityDialog: false,
      deleteEntityDialog: false,
      editSynonymsDialog: false,
      addButtonLoader: false,
      selected: [],
      entityToBeEdited: null,
    };
  },
  computed: {
    queriedEntities() {
      // return this.$store.getters['nlp/intents/query'](this.queries.q)
      return this.$store.state.nlp.entities;
    },
    paginationCount() {
      return this.queriedEntities && this.queriedEntities.length
        ? Math.ceil(
            this.$store.state.nlp.entitiesPagination.entities.count /
              this.pagination.per_page
          )
        : 0;
    },
    selectedEntity() {
      return this.$store.state.nlp.selectedEntity;
    },
    noDataContainerTagStyles() {
      // { minWidth : `${ $refs && $refs.dataTable ? $refs.dataTable.$el.offsetWidth - 60 : 500 }px` }
      let result = {};
      result.minWidth = `${
        this.$refs && this.$refs.dataTable
          ? this.$refs.dataTable.$el.offsetWidth - 60
          : 500
      }px`;
      if (this.$vuetify.clientWidth < 1500) {
        result.paddingLeft = "0";
      } else {
        result.paddingLeft = "25%";
      }
      return result;
    },
    headers() {
      const headers = [
        {
          text: "Items",
          align: "left",
          sortable: true,
          value: "name",
        },
        { text: "Synonyms", value: "synonyms", align: "left" },
      ];
      if (this.$store.state.nlp.sublists.length)
        headers.push({ text: "", value: "name" });
      return headers;
    },
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if (val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]];
        }
      },
    },
    editSynonymsDialog(val) {
      if (!val) {
        this.entityToBeEdited = null;
      }
    },
  },
  mounted() {
    // get entities
    this.getEntity();
  },
  methods: {
    async getEntity(resetPagination) {
      try {
        this.loaders.single = true;
        await this.$store.dispatch(
          "nlp/entities/get/single",
          this.$route.params.entity
        );
        this.loaders.single = false;
        this.getSublists(resetPagination);
      } catch (err) {
        this.loaders.single = false;
        this.$store.dispatch("setErrorMessage", true);
        console.log(err);
      }
    },
    async getSublists(resetPagination) {
      try {
        if (this.loaders.single) {
          return;
        }
        this.loaders.list = true;
        if (resetPagination) {
          this.pagination.page = 1;
        }
        let params = {
          ...this.pagination,
          hideLoading: true,
          id: this.$route.params.entity,
        };
        if (this.queries.q && this.queries.q.length)
          params["filter[name]"] = this.queries.q;
        await this.$store.dispatch("nlp/entities/get/single/sublists", params);
        this.loaders.list = false;
        this.$store.state.nlp.sublists.forEach((sublist) => {
          this.$store.dispatch("nlp/entities/get/single/synonyms", sublist.id);
        });
      } catch (err) {
        this.loaders.list = false;
        this.$store.dispatch("setErrorMessage", true);
      }
    },
    openAddDialog(reset = true) {
      this.$refs[
        `addEntity${this.queriedEntities.length ? "Full" : "Empty"}`
      ].openDialog();
    },
    openEditSynonyms(item) {
      this.entityToBeEdited = item;
      this.editSynonymsDialog = true;
    },
    addSublist(reset = true) {
      this.$refs[
        `addEntitySublist${
          this.$store.state.nlp.sublists.length ? "Full" : "Empty"
        }`
      ].submit();
    },
    addNewEntity() {
      if (this.$refs.addEntity) this.$refs.addEntity.submit();
    },
    selectEntity(entity) {
      this.$store.dispatch("nlp/entities/select", entity);
      // this.$router.push(`/nlp/entity/${entity.id}/entities`)
    },
    clearSearch() {
      this.queries.q = "";
      this.getSublists(true);
    },
    deleteEntities() {
      this.$store.dispatch("setLoader", true);
      this.$store
        .dispatch("nlp/entities/single/sublist/delete", this.selected[0].id)
        .then(() => {
          this.deleteEntityDialog = false;
          this.$store.dispatch("setSnackbar", {
            text: `Deleted Successfully`,
            color: "success",
          });
          this.selected = [];
          this.$store.dispatch("setLoader", false);
          this.getEntity();
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("setErrorMessage", true);
          this.$store.dispatch("setLoader", false);
        });
    },
    handleEditSuccess() {
      this.getEntity();
      this.editSynonymsDialog = false;
    },
  },
};
</script>

<style lang="scss" src="../../../../assets/sass/commponents/nlp.scss"></style>
<style lang="css">
.entities-form-container-tag {
  width: 100%;
  display: flex;
  align-items: flex-start;
  max-height: 400px;
  overflow-y: auto;
}
.entities-form-parrier-tag {
  width: calc(50%);
}
.edit-synonyms-btn {
  float: right;
  padding-right: 5px !important;
  padding-left: 5px !important;
  margin-right: 0 !important;
}
.read-more-container p {
  min-width: 500px;
  width: 500px;
  margin-bottom: 2px !important;
}
</style>
